import React from 'react';
import { DataListSelect } from '@youngcapital/component-library';
import * as yup from 'yup';
import { asFieldset, FIELDSET_PROPTYPES } from '../asFieldset';

const JobTypesFieldset = ({ t, optionsData, getFieldProps }) => {
  const jobTypes = optionsData.job_types || [];

  return (
    <>
      <h3>{t('fieldset_job_types.header')}</h3>
      <DataListSelect
        options={jobTypes}
        label={t('fieldset_job_types.intro')}
        isMulti
        placeholder={t('fieldset_job_types.placeholder')}
        getOptionValue={opt => opt.id}
        getOptionLabel={opt => opt.name}
        {...getFieldProps('job_type_ids', props => ({
          ...props,
          onChange: props.setValue
        }))}
        isRequired
      />
    </>
  );
};

JobTypesFieldset.type = 'job-type';

JobTypesFieldset.propTypes = FIELDSET_PROPTYPES;

JobTypesFieldset.initialValues = () => ({
  job_type_ids: []
});

JobTypesFieldset.validationSchema = () => ({
  job_type_ids: yup.array().min(1)
});

export default asFieldset(JobTypesFieldset, { optionsData: true });
